import React from "react";

interface TagListComponentProps {
    tag: any; // Tag objesi (id ve title içerir)
    tagIndex: number;
    onClick?: () => void;
    type: 'LIST' | 'DELETE' | 'UPDATE';
}

const TagListComponent = ({
    tag,
    tagIndex,
    onClick,
    type
}: TagListComponentProps) => {
    const getBackgroundColor = () => {
        const colors = [
            'bg-blue-200 hover:bg-blue-300',
            'bg-green-200 hover:bg-green-300',
            'bg-purple-200 hover:bg-purple-300',
            'bg-pink-200 hover:bg-pink-300',
            'bg-yellow-200 hover:bg-yellow-300',
            'bg-indigo-200 hover:bg-indigo-300',
            'bg-red-200 hover:bg-red-300',
            'bg-gray-200 hover:bg-gray-300'
        ];
        return colors[tagIndex % colors.length];
    };

    const getCursorStyle = () => {
        return type === 'LIST' ? '' : 'cursor-pointer';
    };

    const getLayoutStyle = () => {
        // Alt alta dizilim için genişlik ve layout
        return type === 'LIST' 
            ? 'min-w-[500px] flex flex-col items-start justify-start px-4 py-3 rounded-lg' 
            : 'min-w-[500px] flex items-center justify-center px-6 py-3 rounded-full';
    };

    return (
        <div
            className={`
                ${getBackgroundColor()} 
                ${getCursorStyle()}
                ${getLayoutStyle()}
                shadow-md 
                transition-all 
                duration-200 
                transform 
                hover:scale-105 
                hover:shadow-lg
                flex
                items-center
                ${type === 'DELETE' ? 'border-2 border-red-400' : ''}
                ${type === 'UPDATE' ? 'border-2 border-blue-400' : ''}
            `}
            onClick={onClick}
        >
            <span className="text-lg font-semibold text-gray-800 select-none">
                {typeof tag === 'string' ? tag : tag.tagTitle || tag.title || tag.name || tag}
            </span>
            {type === 'DELETE' && (
                <span className="ml-auto text-red-600 font-bold"> 🗑️ </span>
            )}
            {type === 'UPDATE' && (
                <span className="ml-auto text-blue-600 font-bold"> ✏️ </span>
            )}
        </div>
    );
};

export default TagListComponent;
